import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "m4.414 13.414 3 3A2 2 0 0 0 8.83 17H17a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2H8.83a2 2 0 0 0-1.415.586l-3 3a2 2 0 0 0 0 2.828m7.293-4.121a1 1 0 1 0-1.414 1.414L11.586 12l-1.293 1.293a1 1 0 1 0 1.414 1.414L13 13.414l1.293 1.293a1 1 0 0 0 1.414-1.414L14.414 12l1.293-1.293a1 1 0 0 0-1.414-1.414L13 10.586z",
      clipRule: "evenodd"
    }
  )
);
var SvgKeypadDeleteFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var KeypadDeleteFilled_default = SvgKeypadDeleteFilled;

export { KeypadDeleteFilled_default as default };
